import React from "react";
import { withTranslation, Trans } from 'react-i18next';
import { updateRoomStatus } from './../models/room';
import { Alert } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from './../components/button';
import moment from 'moment';
import QRCode from "react-qr-code";

class ScreenDressing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: moment().format(),
      error: null,
      isUpdatingStatus: false,
      playedGoodbye: false
    }
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.tick = this.tick.bind(this);
  }

  componentDidMount() {
    this.setUpTick();
  }
  componentWillUnmount() {
    clearInterval(this.intervalID);
  }
  setUpTick() {
    this.tick();
    this.intervalID = setInterval(
      () => this.tick(),
      5000
    );
  }

  tick() {
    const { settings } = this.props;
    let overtime = moment.duration(moment(this.state.time).subtract(settings&&settings.offset&&settings.offset.value,'seconds').diff(this.props.room.effectiveStatusLastChange)).asMinutes()>(settings && settings.dressingMinutes.value);
    let timeSinceDressing = moment.duration(moment(this.state.time).subtract(settings&&settings.offset&&settings.offset.value,'seconds').diff(this.props.room.effectiveStatusLastChange)).asMinutes();
    if(overtime && this.state.overTimeMessage){
      clearInterval(this.intervalID);
    }
    if(!this.state.playedGoodbye && timeSinceDressing>=2 && timeSinceDressing < 2.167){
      this.props.playSound(false, false, false, false, false, false, true);
      this.setState({playedGoodbye: true});
    }
    this.setState({
      time: moment().format(),
      overTimeMessage: overtime
    });
  }

  handleChangeStatus() {
    let roomId = this.props.room.id;
    let status = "Done";

    this.setState({
      isUpdatingStatus: true,
    })

    updateRoomStatus(roomId, status)
      .then(
        result => {
          this.props.handleUpdateRoom(result);
        },
        error => {
          this.setState({
            isUpdatingStatus: false,
            error
          });
        }
      );
  }

  render() {
    const { t, room, settings, siteSettings } = this.props;
    const { error, overTimeMessage } = this.state;
    return (
      <div className="body-right">
        {error!=null
        ? <Alert color="danger">{t("An error occurred.")}</Alert>
        : null}

        <div className="d-flex w-100 justify-content-center">
          {/* {settings&& settings.feedbackLink && settings.feedbackLink.value && settings.publicAppBaseUrl && settings.publicAppBaseUrl.value?
            <div className="col-6 instructions">
              <p>{t("We hope you had a beautiful experience. We appreciate your feedback.")}</p>
              <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "43%", width: "43%" }}
                value={settings.publicAppBaseUrl.value + 'feedback'}
                viewBox={`0 0 256 256`}
                bgColor={"#ffffff00"}
              />
            </div>
          :null} */}
          {siteSettings.showDonateCodeInDressing && settings && settings.publicAppBaseUrl && settings.publicAppBaseUrl.value?
            <div className="col-6 instructions">
              <p>{t("We hope you had a beautiful experience. Please consider making a donation to help maintain and support the Mikvah.")}</p>
              <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "35%", width: "35%" }}
                value={settings.publicAppBaseUrl.value + 'donate'}
                viewBox={`0 0 256 256`}
                bgColor={"#ffffff00"}
              />
            </div>
          :null}
          <div className="instructions">
            {overTimeMessage && siteSettings.hasOvertimeMessage?
              <p>{t("overtimeInstructions")}</p>
            :null}
            {settings&&settings.accesscontrolDoneWaitToExit&&settings.accesscontrolDoneWaitToExit.value==='True'?null:<p><Trans i18nKey={room.reservation.parking?'roomDressingExitParking':'roomDressingExitStreet'} components={[<FontAwesomeIcon icon="parking" />]} /></p>}
            {!room.privateRoom&&!siteSettings.hideDoneInstructions?settings&&settings.accesscontrolDoneWaitToExit&&settings.accesscontrolDoneWaitToExit.value==='True'?null:<p>{t("DoneInstructions")}</p>:null}
            {!room.privateRoom?<p>{t("roomDressingInstructions")}</p>:null}
            {room.privateRoom||(settings&&settings.accesscontrolDoneWaitToExit&&settings.accesscontrolDoneWaitToExit.value==='True')?<Button type="circle-big" onClick={() => this.handleChangeStatus()} loading={this.state.isUpdatingStatus} text={t("I’m Done")} />:null}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ScreenDressing);
